import {useNavigate} from "react-router-dom";
import axios from "axios";
import {useState} from "react";
import Cookies from "universal-cookie/es6";
import {XCircleIcon} from "@heroicons/react/20/solid";
import RedirectToApp from "../utils/RedirectToApp";
import {useEffect} from "react";

export default function Verify() {
    const navigate = useNavigate();

    const [error, setError] = useState("")
    const [verificationCode, setVerificationCode] = useState("")

    const cookies = new Cookies()

    function handleVerificationCodeChange(e) {
        setVerificationCode(e.target.value)
    }
    useEffect(() => {
       let token = cookies.get("token")
        if (!token || token === "")
            navigate("/")
    },[])

    function onSubmit(event) {
        event.preventDefault()
        let now = new Date()
        now.setHours(now.getHours() + 1)
        axios.post(process.env.REACT_APP_API_URL + "verify-otu", { "verification-code" : verificationCode, "token" : cookies.get("token")})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Success")
                    cookies.set('token', response.data["result"]["token"], { expires : now, secure: true, domain: process.env.REACT_APP_COOKIE_NAME, path: '/' });
                    if (response.data["result"]["otp-verified"]) {
                        now.setHours(now.getHours() -1)
                        now.setMonth(now.getMonth() + 1)
                        cookies.set('login-token', response.data["result"]["login-token"], {
                            expires: now,
                            secure: true,
                            domain: process.env.REACT_APP_COOKIE_NAME,
                            path: '/'
                        });
                       RedirectToApp()
                    }
                    else
                        navigate('/setup')
                } else {
                    setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function resend() {
        let now = new Date()
        now.setHours(now.getMinutes() + 5)
        axios.post(process.env.REACT_APP_API_URL + "resend-otu", { "token" : cookies.get("token")})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Success")
                    cookies.set('token', response.data["result"]["token"], { expires : now, secure: true, domain: process.env.REACT_APP_COOKIE_NAME, path: '/' });
                } else {
                    setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    return (

        <div className="flex min-h-full w-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={process.env.REACT_APP_URL + "/images/logo-dark.png"}
                    alt="Your Company"
                />
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Verify your
                    account</h2>
                <p className="mt-4 text-center text-base text-gray-600">
                    A verification code has been sent to your email account.
                </p>
                <p className="mt-4 text-center text-sm text-gray-600">
                    The code will expire in 5 minutes.
                </p>
                <p className="mt-4 text-center text-sm text-gray-600">
                    If you don't receive your code in the next minute or so, use the Resend link below to send another one.
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={(e) => onSubmit(e)}>
                        { error && <div className="border-l-4 border-red-400 bg-red-50 p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <XCircleIcon className="h-5 w-5 text-red-800" aria-hidden="true" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">
                                        {error}
                                    </p>
                                </div>
                            </div>
                        </div>}
                        <div>
                            <label htmlFor="verificationCode" className="block text-sm font-medium text-gray-700">
                                Verification Code
                            </label>
                            <div className="mt-1">
                                <input
                                    id="verificationCode"
                                    name="verificationCode"
                                    type="number"
                                    required
                                    onChange={handleVerificationCodeChange}
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                Verify                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <p className="mt-4 text-center text-sm text-gray-600">
                Didn't get your code? <button onClick={resend} >Resend </button>
            </p>

        </div>
    )
}
